import {EventType} from '../event-type';
import {AnalyticsLogger, SourceType} from '@wix/answers-api';
import axios from 'axios';

export const createAnswersAnalyticsHandler = (
	apiUrl: string, sourceType: SourceType, sourceId: string, locale: string) => {

	return (event: EventType, data: any) => {
		switch (event) {
			case EventType.FIRST_OPEN:
				AnalyticsLogger.sessionStart(axios.post, apiUrl, locale, sourceType, sourceId);
				break;
			case EventType.ARTICLE_VIEW:
				AnalyticsLogger.logPageView(axios.post, apiUrl, locale, sourceType, sourceId, data.articleId);
				break;
			case EventType.SEARCH_IGNORED:
				AnalyticsLogger.logSearchResultIgnored(axios.post, apiUrl, locale, sourceType, sourceId, data.articleId);
				break;
			case EventType.SEARCH_NO_RESULT:
				AnalyticsLogger.logSearchResultNone(axios.post, apiUrl, locale, sourceType, sourceId, data.term);
				break;
			case EventType.SEARCH_RESULT_CLICK:
				AnalyticsLogger.logSearchResultArticleClicked(axios.post,
																			apiUrl,
																			locale,
																			sourceType,
																			sourceId,
																			data.term,
																			data.articleId,
																			data.position);
				break;
			default:
				break;
		}

		return Promise.resolve();
	};
};
